import { validate } from 'cnpj';
import BaseCadastro from "components/BaseCadastro";
import { useToastContext } from "components/alert/ToastContext";
import { Label } from 'components/input/Label';
import CPF from 'cpf-check';
import Parametro from 'model/administracao/cadastro/Parametro';
import ItemInspecaoFrota from 'model/gestao/frotas/ItemInspecaoFrota';
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from "primereact/inputtext";
import { useState } from "react";
import { useForm } from 'react-hook-form';
import { useSearchParams } from "react-router-dom";
import ItemInspecaoFrotaService from 'service/gestao/frotas/ItemInspecaoFrotaService';
import { cnpjMask, cpfMask } from "utils/mask";

const itemInspecaoFrotaService = new ItemInspecaoFrotaService();

export default function ItemInspecaoFrotaCadastro() {

    const [queryParameters] = useSearchParams();

    const { setError, formState: { errors }, register, clearErrors} = useForm();

    const [itemInspecaoFrota, setItemInspecaoFrota] = useState<ItemInspecaoFrota>(new ItemInspecaoFrota());
    const [titulo, setTitulo] = useState<string>('Item de Inspeção');

    const { msgSucesso, msgErro, msgAlerta } = useToastContext();


    function validar() {

        if (!itemInspecaoFrota.nome) {
            setError("nome", {type: "manual", message: "Nome é obrigatório"}, {shouldFocus: true})
            return false;
        }
        return true;
    }

    return (

        <BaseCadastro model={itemInspecaoFrota} service={itemInspecaoFrotaService} novoCadastro
            getNewModel={() => new ItemInspecaoFrota()} setModel={(value: ItemInspecaoFrota) => setItemInspecaoFrota(value)} 
            validar={() => validar()} urlService="/itemInspecaoFrota" pathCadastro="/itemInspecaoFrota" tituloPagina={'ItemInspecaoFrota'}>

            {titulo ?
                <div className="row">
                    <label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">{titulo}</label>
                </div>
                : null}

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Nome</Label>
                <div className="col-sm-12">
                    <InputText required value={itemInspecaoFrota.nome} maxLength={100} style={{ width: '30%' }} 
                        className={errors.nome ? "p-invalid" : ""}
                        {...register("nome",{
                            onChange: (e) => {
                                clearErrors("nome");
                                setItemInspecaoFrota({ ...itemInspecaoFrota, nome: e.target.value })
                            }
                        })}
                    />
                </div>
                {errors.nome && errors.nome.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.nome?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12">Periodicidade Revisão</Label>
                <div className="col-sm-12">
                    <InputNumber value={itemInspecaoFrota.vlPeriodicidadeRevisao} onChange={(e) => setItemInspecaoFrota({ ...itemInspecaoFrota, vlPeriodicidadeRevisao: e.value })}
                        locale='pt-BR' useGrouping={false}
                        style={{ width: '15%', marginRight: '1%' }} 
                    />
                    <Dropdown 
                        options={[{label: 'Dias', value: 'DIAS'}, {label: 'Meses', value: 'MESES'}, {label: 'Anos', value: 'ANOS'}]}
                        optionValue='value'
                        optionLabel='label'
                        value={itemInspecaoFrota.periodicidade} 
                        onChange={(e) => setItemInspecaoFrota({ ...itemInspecaoFrota, periodicidade: e.target.value })} 
                        style={{ width: '14%' }} />
                </div>
            </div>

            <div className="row">
                <Label className="col col-sm-12">Intervalo Quilometragem Revisão</Label>
                <div className="col-sm-12">
                    <InputNumber value={itemInspecaoFrota.intervaloQuilometragemRevisao} onChange={(e) => setItemInspecaoFrota({ ...itemInspecaoFrota, intervaloQuilometragemRevisao: e.value })}
                        locale='pt-BR' useGrouping={false}
                        style={{ width: '30%' }}
                    />
                </div>
            </div>

            <div className="row">
                <Label className="col col-sm-12">Intervalo Horas Revisão</Label>
                <div className="col-sm-12">
                    <InputNumber value={itemInspecaoFrota.intervaloHorasRevisao} onChange={(e) => setItemInspecaoFrota({ ...itemInspecaoFrota, intervaloHorasRevisao: e.value })}
                        style={{ width: '30%' }}
                        locale='pt-BR' useGrouping={false}
                    />
                </div>
            </div>

        </BaseCadastro>
    )
}
